import React from "react";
import { Spinner } from 'reactstrap';
import "./loader.scss";
const LoaderUI = (
    {
        className = '',
        loader = true,
        overlay = false,        
        overlayRadius = 0,
        FullWindow = true,
        color = 'danger',
        size='',
        animation="border"
    }
) => (
        <>
            <div className={`loaderWrapper d-flex align-items-center justify-content-center 
            ${className} 
            ${FullWindow ? 'position-fixed' : 'custom-position'}
            `}>

                {
                    overlay ? <span className={`loaderOverlay position-absolute ${overlayRadius}`}></span> : null
                }
                {
                    loader ? <Spinner color={color} animation={animation} size={size} className={`position-relative large `} /> : null
                }

            </div>
        </>
    );


export default LoaderUI;
